"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPriceAlert2 = function SvgPriceAlert2(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 71",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    d: "m2.737 9.34 2.26 32.865 4.831 2.444L15.595 0l4.435 3.34 3.024 25.277 7.185 6.418 6.835-8.186 5.88 1.768 6.216 20.276 13.329-21.497 5.164 8.344 4.634-2.087 5.115 8.53 3.888 2.768 4.001-2.768 5.184-26.361 8.38 7.526 4.209 14.479 7.514-2.431 5.342 6.787 12.315-23.361 7.391 1.254 6.568 7.594 6.837-8.848 9.119.261 10.268-14.744 7.781 19.158 4.244 30.385 9.432-12.358 5.757 4.299h5.717l3.059 12.127 8.15-2.458L219 69.349"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 38.997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#A2E9C6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#17181A",
    transform: "rotate(10 -25.103 49.505)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.311 1.607c-1.913.117-2.927 1.247-3.04 3.39-.114 2.142-.75 3.451-1.91 3.927-.432.402-.432.733 0 .99.649.389 2.575.841 4.95.841h.05c2.376 0 4.302-.452 4.95-.84.433-.258.433-.589 0-.99-1.16-.477-1.796-1.786-1.91-3.929-.113-2.142-1.126-3.272-3.04-3.39h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.6 10.722c-.04.148-.055.345-.055.505a1.773 1.773 0 1 0 3.546 0c0-.169-.03-.373-.075-.528a15.72 15.72 0 0 1-1.698.088 21.95 21.95 0 0 1-1.718-.065z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.318,
    cy: 0.591,
    r: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 33.997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#A2E9C6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#17181A",
    transform: "rotate(10 -25.103 49.505)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.311 1.607c-1.913.117-2.927 1.247-3.04 3.39-.114 2.142-.75 3.451-1.91 3.927-.432.402-.432.733 0 .99.649.389 2.575.841 4.95.841h.05c2.376 0 4.302-.452 4.95-.84.433-.258.433-.589 0-.99-1.16-.477-1.796-1.786-1.91-3.929-.113-2.142-1.126-3.272-3.04-3.39h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.6 10.722c-.04.148-.055.345-.055.505a1.773 1.773 0 1 0 3.546 0c0-.169-.03-.373-.075-.528a15.72 15.72 0 0 1-1.698.088 21.95 21.95 0 0 1-1.718-.065z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.318,
    cy: 0.591,
    r: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 9.497,
    r: 2.5,
    fill: "#007AFF"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgPriceAlert2);
var _default = Memo;
exports["default"] = _default;